import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SyncProvider } from "@/context/SyncContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import SocietyMaster from "@/pages/SocietyMaster";
import SocietyDetail from "@/pages/SocietyDetail";
import TowerDetail from "@/pages/TowerDetail";
import LiftDetail from "@/pages/LiftDetail";
import SiteDetail from "@/pages/SiteDetail";
import CampaignDetail from "@/pages/CampaignDetail";
import ProofsGallery from "@/pages/ProofsGallery";
import CampaignsList from "@/pages/CampaignsList";
import ClientsList from "@/pages/ClientsList";
import UserMaster from "@/pages/UserMaster";
import ClientDetail from "@/pages/ClientDetail";
import Inspections from "@/pages/Inspections";
import InspectionView from "@/pages/InspectionView";
import Billing from "@/pages/Billing";
import Reports from "@/pages/Reports";
import AuditView from "@/pages/AuditView";
import SyncQueue from "@/pages/SyncQueue";

function Shell() {
  return (
    <ProtectedRoute>
      <SyncProvider>
        <AppShell />
      </SyncProvider>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" richColors theme="light" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Shell />}>
            <Route path="/" element={<Home />} />
            <Route path="/societies" element={<ProtectedRoute roles={["manager", "billing", "society_manager"]}><SocietyMaster /></ProtectedRoute>} />
            <Route path="/societies/:id" element={<SocietyDetail />} />
            <Route path="/towers/:id" element={<TowerDetail />} />
            <Route path="/lifts/:id" element={<LiftDetail />} />
            <Route path="/sites/:id" element={<SiteDetail />} />
            <Route path="/campaigns/:id" element={<CampaignDetail />} />
            <Route path="/proofs" element={<ProofsGallery />} />
            <Route path="/campaigns" element={<ProtectedRoute roles={["manager"]}><CampaignsList /></ProtectedRoute>} />
            <Route path="/clients" element={<ProtectedRoute roles={["admin"]}><ClientsList /></ProtectedRoute>} />
            <Route path="/staff" element={<ProtectedRoute roles={["admin"]}><UserMaster /></ProtectedRoute>} />
            <Route path="/clients/:id" element={<ProtectedRoute roles={["admin", "manager"]}><ClientDetail /></ProtectedRoute>} />
            <Route path="/inspections" element={<ProtectedRoute roles={["manager", "operator"]}><Inspections /></ProtectedRoute>} />
            <Route path="/inspections/:id" element={<ProtectedRoute roles={["manager", "operator"]}><InspectionView /></ProtectedRoute>} />
            <Route path="/billing" element={<ProtectedRoute roles={["billing", "society_manager"]}><Billing /></ProtectedRoute>} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/audit" element={<ProtectedRoute roles={["admin", "manager"]}><AuditView /></ProtectedRoute>} />
            <Route path="/sync" element={<ProtectedRoute roles={["manager", "operator"]}><SyncQueue /></ProtectedRoute>} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
